module.exports = __webpack_public_path__ + "static/img/4.6e4a6b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/4.jpg
// module id = ONfx
// module chunks = 1